<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11wx3ho/media/FC-9781528908535.jpg?1684515369773" alt="This image is the cover for the book A Suitcase Full of Boomerangs"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Suitcase Full of Boomerangs
      </h1>
      <p class="bookDescription body article font2">
        <p>A Suitcase Full of Boomerangs is essentially a romp around the Republic of Ireland. Tiny boomerangs are bequeathed to colourful characters encountered throughout the three-week round trip. Narrated in the first person, the protagonist and two of her sisters manage to have a ball as they traverse the width and breadth of Ireland in a big black jeep filled with suitcases full of boomerangs. This book of travel laughs, mishaps and adventures is a light-hearted, feel-good read, intended to whisk the armchair traveller far away to another time and place – the magic that will always be Ireland.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Fil Bufalo
      </h2>
      
      <p class="authorDescription body article">Fil Bufalo has been writing for a lifetime—on the sand, on slate and in shorthand. An animated storyteller and accomplished raconteur, she has gathered all her thoughts, philosophies and musings on life into a bonfire of words and taken the plunge with a match.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?afdf8f32